import type { PickerOption } from '../store/schema/CompositePickerInterfaces';
import type CompositePickerStore from '../store/schema/CompositePickerStore';

/**
 * Get the previous selectable option from the list of options before the specified index
 * @param index
 */
export default function getPreviousSelectableOption(
    viewState: CompositePickerStore,
    index: number
): PickerOption {
    const { filteredOptions } = viewState;
    let previousSelectableOption = null;
    let lastSelectableOptionAfter = null;

    for (let option of filteredOptions) {
        for (let leafOption of option.leafOptions) {
            if (
                leafOption.index < index &&
                leafOption.isShown &&
                ((previousSelectableOption && leafOption.index > previousSelectableOption.index) ||
                    !previousSelectableOption)
            ) {
                previousSelectableOption = leafOption;
            }

            if (
                leafOption.index > index &&
                leafOption.isShown &&
                ((lastSelectableOptionAfter &&
                    leafOption.index > lastSelectableOptionAfter.index) ||
                    !lastSelectableOptionAfter)
            ) {
                lastSelectableOptionAfter = leafOption;
            }
        }

        if (option.parentOptions) {
            for (let parent of option.parentOptions) {
                if (
                    parent.index < index &&
                    parent.isShown &&
                    ((previousSelectableOption && parent.index > previousSelectableOption.index) ||
                        !previousSelectableOption)
                ) {
                    previousSelectableOption = parent;
                }

                if (
                    parent.index > index &&
                    parent.isShown &&
                    ((lastSelectableOptionAfter &&
                        parent.index > lastSelectableOptionAfter.index) ||
                        !lastSelectableOptionAfter)
                ) {
                    lastSelectableOptionAfter = parent;
                }

                for (let child of parent.children) {
                    if (
                        child.index < index &&
                        child.isShown &&
                        ((previousSelectableOption &&
                            child.index > previousSelectableOption.index) ||
                            !previousSelectableOption)
                    ) {
                        previousSelectableOption = child;
                    }

                    if (
                        child.index > index &&
                        child.isShown &&
                        ((lastSelectableOptionAfter &&
                            child.index > lastSelectableOptionAfter.index) ||
                            !lastSelectableOptionAfter)
                    ) {
                        lastSelectableOptionAfter = child;
                    }
                }
            }
        }
    }

    return previousSelectableOption ? previousSelectableOption : lastSelectableOptionAfter;
}
